import React from 'react';
import HRTeamPage from '../../pages/hr/team-management';
import ViewTeamPage from '../../pages/hr/team-management/view-team';
import ProtectedRoute from '../protected';

export const HRTeamsRoutes = [
  <ProtectedRoute exact path='/team' component={HRTeamPage} />,
  <ProtectedRoute exact path='/team/view/:id' component={ViewTeamPage} />,
];